import React from "react";
import { Form } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

import "./Switch.scss";

interface SwitchProps {
  name: string; // The name of the field used in the form
  label?: string; // The label of the field
  disabled?: boolean; // Whether the field is disabled
  onChange?: (checked: boolean) => void; // Function to handle switch state changes
}

// A switch component that can be used in a form
function Switch(props: SwitchProps) {
  const { name, label, disabled, onChange } = props;
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target;
    if (onChange) {
      onChange(checked);
    }
  };

  return (
    <div className="switch d-flex align-items-center mb-3">
      {/** Switch */}
      <Form.Check {...register(name)} type="switch" name={name} id={name} disabled={disabled} onChange={handleChange} />
      <div className="pl-3 pt-1">{label}</div>
      {/** Field errors */}
      {errors[name]?.message && <div className="d-block font-b3 invalid-feedback">{errors[name]?.message}</div>}
    </div>
  );
}

Switch.defaultProps = {
  label: "",
  disabled: false,
  onChange: undefined,
};

export default Switch;
